import { FormattedMessage } from 'components/shared/Intl';
import { FC } from 'react';
import type { OtcClient } from 'state/secondaryMarket/shared/referential/referential.model';
import styled from 'styled-components';

import type { SearchResultProps } from '../SelectSearch/SelectSearch';
import { OtcSearchResultItem } from './OtcSearchResultItem';

export const StyledDiv = styled.div`
  max-height: 16rem;
`;
export const OtcSearchResult: FC<SearchResultProps<OtcClient>> = ({ data, onSelected, currentIndex, searchedText }) => {
  if (data.length === 0) {
    return null;
  }
  return (
    <StyledDiv className="overflow-y-auto border-top mt-2">
      <table className="table table-hover table-sm" data-e2e="client-search-items">
        <thead>
          <tr>
            <th>
              <FormattedMessage id="client.origin.orderBook" />
            </th>
            <th>
              <FormattedMessage id="client.name" />
            </th>
            <th>
              <FormattedMessage id="client.eliotCode" />
            </th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, idx) => (
            <OtcSearchResultItem
              key={item.eliotCode}
              item={item}
              onSelected={onSelected}
              isSelected={idx === currentIndex}
              searchedText={searchedText}
            />
          ))}
        </tbody>
      </table>
    </StyledDiv>
  );
};
OtcSearchResult.displayName = 'OtcSearchResult';
